import { PAGES } from 'consts/pages';
import { PRESET_OPTIONS, type PresetOption } from 'consts/dashboard';
import { INDICATORS_CONFIG } from 'consts/logtype';
import type { Page } from 'consts/pages';

export type Widget = PresetOption['defaultWidgets'][number];

export type CustomDashboard = { id: string; layout: unknown };

export type ColumnsConfig = {
  log: Record<string, string[]>;
  [page: string]: string[] | Record<string, string[]>;
};

export type DashboardConfig = {
  version: number;
  bookmarks: unknown[];
  pql: unknown[];
  timechartBreakdown: Record<string, string | null>;
  columnsConfig: ColumnsConfig;
  presets: Record<string, Record<string, Widget[]>>;
  customDashboards: CustomDashboard[];
};

export const DASHBOARDS = [
  PAGES.events,
  PAGES.indicators,
  PAGES.investigator,
  PAGES.cloudapi,
  PAGES.identityManagement,
];

// these are exceptions because INDICATORS_CONFIG has `indicator.key` as keys and not `indicator.log`
// since we don't have ET and platform defined with `log` in the config, we need to add them manually here
const ADDITIONAL_INDICATORS = ['entity-track', 'platform'];
export const toKeys = (agg: Record<string, string[]>, logType: string): Record<string, string[]> => ({
  ...agg,
  [logType]: [],
});

const indicatorColumnsConfig = Object.keys(INDICATORS_CONFIG).concat(ADDITIONAL_INDICATORS).reduce(toKeys, {});

export const CONFIG_VERSION = 2;

export const INITIAL_CONFIG: DashboardConfig = {
  version: CONFIG_VERSION,
  bookmarks: [],
  pql: [],
  timechartBreakdown: {
    [PAGES.events]: null,
    [PAGES.indicators]: null,
    [PAGES.investigator]: null,
  },
  columnsConfig: {
    log: indicatorColumnsConfig,
    ...DASHBOARDS.reduce<Record<string, string[]>>((acc, x) => ({ ...acc, [x]: [] }), {}),
  },
  presets: (Object.keys(PRESET_OPTIONS) as Page[]).reduce<Record<string, Record<string, Widget[]>>>(
    (acc, x) => ({
      ...acc,
      [x]: (PRESET_OPTIONS[x] ?? []).reduce<Record<string, Widget[]>>(
        (presetAcc, preset) => ({ ...presetAcc, [preset.value]: preset.defaultWidgets }),
        {},
      ),
    }),
    {},
  ),
  customDashboards: [],
};
